export const OPEN_MESSAGE = 'e:notification:open';
export const BUTTON_CLICK_MESSAGE = 'e:notification:button:click';
export const CLIENT_CLOSE_MESSAGE = 'e:notification:close:client';
export const SERVICE_CLOSE_MESSAGE = 'e:notification:close:service';

export const BOTTOM_RIGHT_PLACEMENT = 'bottom-right';

export const AUTO_CLOSE_DURATION = 5000;
